export const LOAD_UNITS = 'LOAD_UNITS'
export const ADD_UNIT = 'ADD_UNIT'
export const UPDATE_UNIT = 'UPDATE_UNIT'
export const DELETE_UNIT = 'DELETE_UNIT'
export const LOAD_ALL_UNITS = 'LOAD_ALL_UNITS'
